"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockStream = void 0;
/**
 * 模拟 SSE 流式输出
 */
class MockStream {
    /**
     * 创建一个模拟流式输出实例
     * @param options - 配置选项
     * @param options.str - 需要输出的字符串
     * @param options.outputLength - 每次输出的字符数量（默认值：200）
     * @param options.duration - 每次输出的时间间隔，单位毫秒（默认值：100）
     */
    constructor(options) {
        /** 需要输出的字符串 */
        this.str = '';
        /** 每次输出的字符数量 */
        this.outputLength = 0;
        /** 每次输出的时间间隔（毫秒） */
        this.duration = 0;
        this.str = options.str;
        this.outputLength = options.outputLength || 200;
        this.duration = options.duration || 100;
    }
    /**
     * 开始模拟流式输出
     * @param callback - 接收输出内容的回调函数
     * @returns 返回一个 Promise，当所有内容输出完成时，Promise 将解析为 true
     */
    start(callback) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
                let startIndex = 0;
                while (startIndex < this.str.length) {
                    const endIndex = Math.min(startIndex + this.outputLength, this.str.length);
                    callback(this.str.slice(startIndex, endIndex));
                    startIndex = endIndex;
                    if (startIndex < this.str.length) {
                        yield new Promise(resolve => setTimeout(resolve, this.duration));
                    }
                }
                resolve(true);
            }));
        });
    }
}
exports.MockStream = MockStream;
//# sourceMappingURL=mockStream.js.map